/*
 * MQTT client singleton
 * Connects to HiveMQ public broker over WSS (port 8884)
 */
import mqtt from 'mqtt';

const BROKER_URL = 'wss://broker.hivemq.com:8884/mqtt';
const CLIENT_ID  = `smartpatch_dashboard_${Math.random().toString(16).slice(2, 8)}`;

const TOPICS = {
  ECG    : 'smartpatch/athlete01/ecg',
  HR     : 'smartpatch/athlete01/heartrate',
  SPO2   : 'smartpatch/athlete01/spo2',
  TEMP   : 'smartpatch/athlete01/temperature',
  MOTION : 'smartpatch/athlete01/motion',
  ALERT  : 'smartpatch/athlete01/alert',
  AUTH   : 'smartpatch/athlete01/auth',
  CMD    : 'smartpatch/athlete01/cmd',
};

let client = null;

export function getClient() {
  if (!client) {
    client = mqtt.connect(BROKER_URL, {
      clientId   : CLIENT_ID,
      clean      : true,
      reconnectPeriod: 3000,
    });

    client.on('connect', () => {
      console.log('[MQTT] Connected to HiveMQ');
      Object.values(TOPICS)
        .filter(t => t !== TOPICS.CMD)
        .forEach(t => client.subscribe(t));
    });

    client.on('error', err => console.error('[MQTT] Error:', err));
    client.on('reconnect', () => console.log('[MQTT] Reconnecting...'));
  }
  return client;
}

export function sendCommand(cmd) {
  const c = getClient();
  if (c.connected) {
    c.publish(TOPICS.CMD, cmd);
  }
}

export { TOPICS };
